import { createTheme } from "@mui/material";

import LitcoX from "../assets/icons/LitcoX";
import Litco from "../assets/icons/Litco";
import LitcoCheck from "../assets/icons/LitcoCheck";

const headingFontFamily = ["DM Serif Display", "Arial"].join(",");
const bodyFontFamily = ["Museo Sans", "Arial"].join(",");
const fontUnity = "rem";
const fontSizeBase = 0.875;
const fontLineHeightBase = 1.25;

//Using web colors from brand bible and alerts colours guideline
const theme = createTheme({
  palette: {
    background: { default: "#f6f5f4" }, //Litco Law brand off-white
    primary: { main: "#ff5100", contrastText: "#ffffff" }, //main: Litco Law brand orange, contrastText: Button text color
    secondary: { main: "#5FD0DF" }, //Litco Law brand light blue
    header: { main: "#201751" }, //Litco Law brand dark blue
    error: { main: "#FF0000" }, //red but within the same tone as our brand orange
    warning: { main: "#FF9D00" }, //yellow but within the same tone as our brand orange
    info: { main: "#5FD0DF" }, //Litco Law brand light blue
    success: { main: "#007565" }, //Litco Law brand green
  },

  typography: {
    fontFamily: bodyFontFamily,
    h1: {
      fontFamily: headingFontFamily,
      fontSize: `${fontSizeBase * 1.8}${fontUnity}`,
      lineHeight: `${fontLineHeightBase + 0.5}${fontUnity}`,
    },
    h2: {
      fontFamily: headingFontFamily,
      fontSize: `${fontSizeBase * 1.7}${fontUnity}`,
      lineHeight: `${fontLineHeightBase + 0.5}${fontUnity}`,
    },
    h3: {
      fontFamily: headingFontFamily,
      fontSize: `${fontSizeBase * 1.6}${fontUnity}`,
      lineHeight: `${fontLineHeightBase + 0.5}${fontUnity}`,
    },
    h4: {
      fontFamily: headingFontFamily,
      fontSize: `${fontSizeBase * 1.5}${fontUnity}`,
      lineHeight: `${fontLineHeightBase + 0.5}${fontUnity}`,
    },
    h5: {
      fontFamily: headingFontFamily,
      fontSize: `${fontSizeBase * 1.4}${fontUnity}`,
      lineHeight: `${fontLineHeightBase + 0.5}${fontUnity}`,
    },
    h6: {
      fontFamily: headingFontFamily,
      fontSize: `${fontSizeBase * 1.3}${fontUnity}`,
      lineHeight: `${fontLineHeightBase + 0.5}${fontUnity}`,
    },
    subtitle1: {
      fontFamily: headingFontFamily,
      fontSize: `${fontSizeBase * 1.1}${fontUnity}`,
      lineHeight: `${fontLineHeightBase}${fontUnity}`,
      color: "#8f97aa",
    },
    subtitle2: {
      fontFamily: headingFontFamily,
      fontSize: `${fontSizeBase * 1.1}${fontUnity}`,
      lineHeight: `${fontLineHeightBase}${fontUnity}`,
      fontWeight: 700,
    },
    body1: { fontSize: `${fontSizeBase}${fontUnity}`, lineHeight: `${fontLineHeightBase}${fontUnity}` },
    label: {
      fontSize: `${fontSizeBase * 0.9}${fontUnity}`,
      lineHeight: `${fontLineHeightBase}${fontUnity}`,
      color: "rgba(0, 0, 0, 0.5)",
    },
  },

  props: {
    MuiAlert: {
      iconMapping: {
        error: <LitcoX fontSize="inherit" />,
        success: <LitcoCheck fontSize="inherit" />,
        warning: <LitcoX fontSize="inherit" />,
        info: <Litco fontSize="inherit" />,
      },
    },
  },
});

export default theme;
